<div *ngIf="title$ | async">
  <strong>Title:</strong>&nbsp;<em>{{ title$ | async }}</em>
</div>
